import CarOverview from '@/components/organisms/carOverview'
import NotFound from '@/components/organisms/notFound'
import CarSEO from '@/components/seo/carSEO'
import GlobalCtx, { IGlobalCtx } from '@/context/global'
import { mock_car } from '@/context/mock_data'
import { converError } from 'data_conversions/convertError'
import { convertGarageCarApiToCtxCar } from 'data_conversions/garageCarApiConversion'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { ICar, IError } from 'shared-interfaces'

// NEW CODE
// This gets called on every request
export async function getServerSideProps(context: any) {
    // let cookies = cookie.parse(
    //     (context.req && context.req.headers.cookie) || ''
    // )

    // let hasCarAlreadyBeenAccessed = cookies.session_car_data

    // if (hasCarAlreadyBeenAccessed !== 'ok') {
    // // Fetch data from external API
    const requestOptions: RequestInit = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    }

    const res = await fetch(
        `${process.env.API_BASE_URL}/public/shares/garage-${context.query.link_id}/garage/car/${context.query.car_id}`,
        requestOptions
    )

    const data = await res.json()

    if (data) {
        if (data.owner) {
            let car: ICar | null = convertGarageCarApiToCtxCar({
                ...data,
                uid: context.query.link_id,
            })
            // cookie.serialize('session_car_data', 'ok')
            return {
                props: { car: car, host: context.req.headers.host },
            }
        } else {
            let error: IError | null = converError({
                ...data,
                uid: context.query.link_id,
            })
            // cookie.serialize('session_car_data', 'ok')
            return {
                props: { error: error },
            }
        }
    }
}

const Car = (props: { car?: ICar; error?: IError; host: string }) => {
    const router = useRouter()

    const globalCtx: IGlobalCtx = React.useContext(GlobalCtx)

    useEffect(() => {
        if (router.query.link_id === 'garageid') {
            globalCtx.setCar(mock_car)
        } else if (props.car) {
            globalCtx.setCar(props.car)
        } else if (props.error) {
            globalCtx.setCar(null)
            globalCtx.setError(props.error)
        }
    }, [props, globalCtx, router])

    return props.car || globalCtx.car ? (
        <>
            <CarSEO
                carData={props.car}
                url={`https://${props.host}${router.asPath}`}
            />
            <CarOverview />
        </>
    ) : (
        <NotFound />
    )
}

export default Car
